import { render, staticRenderFns } from "./BotaoTutorial.vue?vue&type=template&id=4cb7a794&"
import script from "./BotaoTutorial.vue?vue&type=script&lang=js&"
export * from "./BotaoTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports